import { Helpers } from '../../helpers';
import { IPermitType } from '../../interfaces/ipermit-type';
import { ProjectPondParameter } from '../project-pond-parameter';
import { Well } from '../well';

export class PermitTypeBase {
  PermitTypeId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_PermitType?: Array<ProjectPondParameter> | null;
  Wells_PermitType?: Array<Well> | null;

  constructor(item?: IPermitType) {
    if (item) {

      this.PermitTypeId = item.PermitTypeId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_PermitType = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_PermitType);
      this.Wells_PermitType = Helpers.createClassArray(Well, item.Wells_PermitType);
    }
  }
}